import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Delete, ArrowBack } from "@mui/icons-material";
import { getInvertColor } from "utils/themeUtils";
import { useIntl } from "react-intl";

type Props = {
	mobileHeadbarVariant: MobileHeadBarVariant;
	emailSubject?: string;
	action?: string;
	setMobileHeadbarVariant: (mobileHeadBarVariant: MobileHeadBarVariant) => void;
	setAction: (action: string) => void;
	setAlertOpen: (isOpen: boolean) => void;
};

export enum MobileHeadBarVariant {
	HOME = "home",
	EMAILLISTING = "emailCardListing",
	EMAIL = "email",
}

const HeadBar: React.FC<Props> = ({
	mobileHeadbarVariant,
	emailSubject,
	action,
	setMobileHeadbarVariant,
	setAction,
	setAlertOpen,
}) => {
	const classes = useStyles();
	const intl = useIntl();
	const subjectLine =
		emailSubject && emailSubject.length > 30 ? emailSubject?.substring(0, 30).concat("...") : emailSubject;

	return (
		<>
			{mobileHeadbarVariant === MobileHeadBarVariant.HOME && (
				<div className={`${classes.container} ${classes.home}`}>
					<Typography className={classes.typography}>{action}</Typography>
				</div>
			)}
			{mobileHeadbarVariant === MobileHeadBarVariant.EMAILLISTING && (
				<div className={`${classes.container} ${classes.emailCardListing}`}>
					<div className={`${classes.subBlock} ${classes.subBlockLeft}`}>
						<ArrowBack
							className={classes.icon}
							onClick={() => {
								setMobileHeadbarVariant(MobileHeadBarVariant.HOME);
								setAction(intl.formatMessage({ id: "EMAIL.headbar.mobile.mailbox" }));
							}}
						/>
						<Typography className={classes.typography}>{action}</Typography>
					</div>
					<div className={`${classes.subBlock} ${classes.subBlockRigth}`}>
						<Delete className={classes.icon} onClick={() => setAlertOpen(true)} />
					</div>
				</div>
			)}
			{mobileHeadbarVariant === MobileHeadBarVariant.EMAIL && (
				<div className={`${classes.container} ${classes.subBlockLeft}`}>
					<div style={{ display: "flex", columnGap: 10 }}>
						<ArrowBack
							className={classes.icon}
							onClick={() => {
								setMobileHeadbarVariant(MobileHeadBarVariant.EMAILLISTING);
							}}
						/>
						<Typography className={classes.typography}>{subjectLine}</Typography>
					</div>
				</div>
			)}
		</>
	);
};

const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		alignItems: "center",
		width: "100%",
	},
	home: {
		justifyContent: "center",
	},
	emailCardListing: {
		justifyContent: "space-between",
	},
	subBlock: {
		display: "flex",
		alignItems: "center",
		width: "fit-content",
	},
	subBlockLeft: {
		columnGap: 10,
		marginLeft: 10,
	},
	subBlockRigth: {
		columnGap: 10,
		marginRight: 10,
	},
	typography: {
		color: getInvertColor(theme.palette.primary.main),
		fontWeight: "bold",
	},
	icon: {
		color: getInvertColor(theme.palette.primary.main),
	},
}));

export default HeadBar;
